import React, { useEffect ,useState} from 'react'
import axios from 'axios';
import config from '../../../config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../../Components/Pagination/Pagination'
import { ChevronRight , ChevronLeft, CheckSquare} from 'lucide-react';




const ListAppointmentFailed = () => {

    const [appointment, setAppointment] = useState([]);
        const [index, SetIndex] = useState(0);
        const [size, SetSize] = useState(1000);
        const [View1Pagination, SetView1Pagination] = useState(true);
        const [View2Pagination, SetView2Pagination] = useState(false);
    
    const navigate = useNavigate();
  
    // Fonction pour récupérer les Consultations de l'utilisateur
    const getAppointment = async () => {
        try {
            const token = localStorage.getItem("accessToken"); // Assurez-vous que le token est stocké ici
            const response = await axios.post(`${config.FIS_API_SITE}/getuserconsultationfailed`, {
              index: index,
              size: size,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
    
      setAppointment(response.data.result || []); // Extraire le tableau Appointment
        } catch (error) {
            toast.error(error.response?.data?.message || "Erreur lors de la récupération des Consultations");
        }
    };
    // Appeler fetchAppointment au montage du composant
    useEffect(() => {
      getAppointment();
    }, []);

 // Gestion des clics sur les numéros de page
 const handleClickpaginate = (e) => {
  const page = parseInt(e.target.value, 10);
  SetIndex(page);
  getAppointment(page, size);
};

// Gestion du changement dans le select (nombre d'éléments par page)
const onChangeSelectpagination = (e) => {
  const newLimit = parseInt(e.target.value, 10);
  SetSize(newLimit);
  getAppointment(1, newLimit); // Revenir à la première page avec le nouveau limit
  SetIndex(1);
  SetView1Pagination(true);
  SetView2Pagination(false);
};
  return (
    <div className="mt-4">
        <h3 className="mb-4">Liste des Consultation Échouée</h3>
            <div class="relative flex flex-col w-full h-full overflow-scroll text-gray-700 bg-white shadow-md rounded-lg bg-clip-border">
    <table class="w-full text-left table-auto min-w-max">
        <thead>
        <tr>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-center text-sm font-normal leading-none text-slate-500">
                N° Consultation
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-center text-sm font-normal leading-none text-slate-500">
                Nom et Prénom
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-center text-sm font-normal leading-none text-slate-500">
                email
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-center text-sm font-normal leading-none text-slate-500">
                phone
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-center text-sm font-normal leading-none text-slate-500">
                description
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-center text-sm font-normal leading-none text-slate-500">
                Date
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-center text-sm font-normal leading-none text-slate-500">
                Heure
            </p>
            </th>
        </tr>
        </thead>
        <tbody>
        {appointment?.map((o, i) => (
                  <tr key={i} className="hover:bg-slate-50 border-b border-slate-200">
                    <td className="p-4">
                      <p className="text-center block font-semibold text-sm text-slate-800">{o?.code_consultation}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-center block font-semibold text-sm text-slate-800">{o?.appointmentId?.last_name} {o?.appointmentId?.first_name}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-center text-sm text-slate-500">{o?.appointmentId?.email}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-center text-sm text-slate-500">{o?.appointmentId?.phone}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-center text-sm text-slate-500">{o?.appointmentId?.description}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-center text-sm text-slate-500">{o?.appointmentId?.date}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-center text-sm text-slate-500">
                        {o?.appointmentId?.hour}
                      </p>
                    </td>
                  </tr>
                ))}
        </tbody>
    </table>
    
          {/* Nouvelle pagination */}
          <div className="flex flex-wrap items-center mt-3 intro-y min-sm:flex-row min-sm:flex-nowrap">
            <Pagination className="w-full min-sm:w-auto min-sm:mr-auto">
              {View1Pagination && (
                <>
                  <Pagination.Link>
                   <ChevronLeft className="w-4 h-4" />
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={1} onClick={handleClickpaginate}>
                      1
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={2} onClick={handleClickpaginate}>
                      2
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={3} onClick={handleClickpaginate}>
                      3
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <ChevronRight
                      className="w-4 h-4"
                      onClick={() => {
                        SetView1Pagination(false);
                        SetView2Pagination(true);
                        SetIndex(4);
                        getAppointment(4, size);
                      }}
                    /> 
                  </Pagination.Link>
                </>
              )}
              {View2Pagination && (
                <>
                  <Pagination.Link>
                    <ChevronLeft
                      className="w-4 h-4"
                      onClick={() => {
                        SetView1Pagination(true);
                        SetView2Pagination(false);
                        SetIndex(1);
                        getAppointment(1, size);
                      }}
                    /> 
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={4} onClick={handleClickpaginate}>
                      4
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={5} onClick={handleClickpaginate}>
                      5
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={6} onClick={handleClickpaginate}>
                      6
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <ChevronRight className="w-4 h-4" /> 
                  </Pagination.Link>
                </>
              )}
            </Pagination>
            <select
              className="w-20 mt-3 p-2 m-3 border rounded-md shadow-sm min-sm:mt-0 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={onChangeSelectpagination}
            >
              <option value={1000}>1000</option>
              <option value={2000}>2000</option>
              <option value={3000}>3000</option>
              <option value={4000}>4000</option>
              <option value={5000}>5000</option>
            </select>
          </div>
    </div>
      </div>
  )
}

export default ListAppointmentFailed